<div class="w-full flex flex-col rounded-md border border-gray-200 dark:border-gray-800 p-4 gap-4">
    <div class="border-b border-gray-900/10 dark:border-white/10">
        <h2 class="text-lg font-medium">Advertiser Account</h2>
        <p class="mb-1 text-sm/6 text-gray-600 dark:text-gray-400">Select the advertiser account for your campaign.
        </p>
    </div>

    @if (singleAdvertiserAccount() !== undefined) {
    <div class="w-full flex flex-row items-center justify-start gap-2">
        <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium inset-ring inset-ring-gray-500/10 dark:inset-ring-gray-400/20"
        [class]="getAdvertiserAccountClass(singleAdvertiserAccount()!)">{{ singleAdvertiserAccount() }}</span>
    </div>
    } @else if (multipleAdvertiserAccounts() !== undefined && multipleAdvertiserAccounts()!.length > 1) {
    <div class="w-full flex flex-row items-center justify-start gap-2">
        @for (account of multipleAdvertiserAccounts()!; track account) {
            <span (click)="selectAdvertiserAccount(account)" class="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 inset-ring inset-ring-gray-500/10 dark:bg-gray-400/10 dark:text-gray-400 dark:inset-ring-gray-400/20">{{ account }}</span>
            @if (createSparkCampaignService.selectedAdvertiserAccountId() === account) {
                <span class="inline-flex items-center rounded-md bg-primary px-2 py-1 text-xs font-medium text-white inset-ring inset-ring-primary/10 dark:bg-primary/15 dark:text-white dark:inset-ring-primary/25">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5 text-white">
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                </span>
            }
            @else {
                <span class="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 inset-ring inset-ring-gray-500/10 dark:bg-gray-400/10 dark:text-gray-400 dark:inset-ring-gray-400/20">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                </span>
            }
        }
    </div>
    }


</div>